import { MessageDescriptor } from 'react-intl';

export type SurveyBuilderQuestionTypes =
  | 'textarea'
  | 'checkbox'
  | 'photo'
  | 'single-question'
  | 'dropdown-question'
  | 'table-group'
  | 'lifeology-course'
  | 'image'
  | 'genomics-report'
  | 'signature';

export const questionTypeMessageDescriptors = {
  textarea: {
    id: 'surveyBuilder.editControlContainer.labels.textArea',
    defaultMessage: 'Text',
  } as MessageDescriptor,
  checkbox: {
    id: 'surveyBuilder.editControlContainer.labels.checkbox',
    defaultMessage: 'Checkbox',
  } as MessageDescriptor,
  photo: {
    id: 'surveyBuilder.editControlContainer.labels.photo',
    defaultMessage: 'Photo',
  } as MessageDescriptor,
  'single-question': {
    id: 'surveyBuilder.editControlContainer.labels.singleQuestion',
    defaultMessage: 'Single Textbox',
  } as MessageDescriptor,
  'dropdown-question': {
    id: 'surveyBuilder.editControlContainer.labels.dropdown',
    defaultMessage: 'Multiple Choice',
  } as MessageDescriptor,
  'table-group': {
    id: 'surveyBuilder.editControlContainer.labels.tableGroup',
    defaultMessage: 'Matrix',
  } as MessageDescriptor,
  'lifeology-course': {
    id: 'surveyBuilder.editControlContainer.labels.lifeologyCourse',
    defaultMessage: 'Lifeology Course',
  } as MessageDescriptor,
  image: {
    id: 'surveyBuilder.editControlContainer.labels.image',
    defaultMessage: 'Image',
  } as MessageDescriptor,
  'genomics-report': {
    id: 'surveyBuilder.editControlContainer.labels.genomicsReport',
    defaultMessage: 'Genomics Report',
  } as MessageDescriptor,
  signature: {
    id: 'surveyBuilder.editControlContainer.labels.signature',
    defaultMessage: 'Signature',
  } as MessageDescriptor,
};
